import { render, staticRenderFns } from "./mutil-text-link.vue?vue&type=template&id=ff3bfa2e&scoped=true&"
import script from "./mutil-text-link.vue?vue&type=script&lang=ts&"
export * from "./mutil-text-link.vue?vue&type=script&lang=ts&"
import style0 from "./mutil-text-link.vue?vue&type=style&index=0&id=ff3bfa2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3bfa2e",
  null
  
)

export default component.exports